import type { ReatomSolanaContainer } from "@rarible_int/anaconda_sdk/solana"
import { action, atom } from "@reatom/core"
import { molecule } from "bunshi"

export const SolanaSdkContainerMoleculeReatom = molecule(() => {
  const sdkContainerAtom = atom<ReatomSolanaContainer | null>(
    null,
    "solanaSdkContainerAtom",
  )

  const updateSdk = action(
    (sdk: ReatomSolanaContainer | null, source: string) => {
      sdkContainerAtom.set(sdk)
    },
    "updateSolanaSdk",
  )

  const clearSdk = action(() => {
    sdkContainerAtom.set(null)
  }, "clearSolanaSdk")

  return {
    sdkContainerAtom,
    updateSdk,
    clearSdk,
  }
})
